import * as v from "@badrap/valita";

import { $NonNegativeInteger, $Percentage } from "./misc.ts";

export const $ProductId = v.string();

export type ProductId = v.Infer<typeof $ProductId>;

export const $Product = v
  .object({
    id: $ProductId,
    name: v.string(),
    background: $NonNegativeInteger,
    priceBeforeVat: $NonNegativeInteger,
    priceAfterVat: $NonNegativeInteger,
    vat: $Percentage,
  })
  .assert(
    ({ priceBeforeVat, vat, priceAfterVat }) =>
      priceAfterVat === priceBeforeVat + Math.round(priceBeforeVat * vat),
  );

export type Product = v.Infer<typeof $Product>;

export const $ProductNew = v.object({
  name: v.string(),
  background: $NonNegativeInteger,
  priceBeforeVat: $NonNegativeInteger,
  vat: $Percentage,
});

export type ProductNew = v.Infer<typeof $ProductNew>;
